import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/periods/2/bg.jpg")